import { COLOR2, ORIENTAL_D_GRAY } from '../../constants';

export const DGIProductUIStyles = {
  adjust_me: {
    padding: '0px 12px !important',
    '@media (max-width:960px)': {
      padding: '0px 8px !important',
    },
    '@media (min-width:600px) and (max-width:960px)': {
      padding: '0px 12px !important',
    },
  },

  select_inputs_placeholder: {
    background: 'rgba(85, 88, 88, 0.02) 0% 0% no-repeat padding-box',
    textAlign: 'left',
    fontWeight: 300,
    lineHeight: '16px',
    fontStyle: 'normal',
    fontSize: '14px',
    letterSpacing: '0.1px',
    color: ORIENTAL_D_GRAY,
    opacity: 0.8,
  },

  error_message_product: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    marginTop: '4px',
    display: 'block',
  },

  notchedOutline: {
    border: '1px solid #E4E9F2',
    borderRadius: '6px',
  },

  notchedOutlineErr: {
    border: `1px solid ${COLOR2}`,
    borderRadius: '6px',
  },
};
